import React, { useRef, useState } from 'react';

import Button from '@mui/material/Button';
import CloudDownloadIcon from '@mui/icons-material/CloudDownload';
import { CustomLoadingProgress } from '../../../shared/components/CustomLoadingProgress';
import FileService from '../../../shared/services/FileService';
import Grid from '@mui/material/Unstable_Grid2';

interface IDownloadComponentProps {
  filename: string;
  url?: string | null;
  blob?: Blob;
}

const FileDownloadComponent = (props: IDownloadComponentProps) => {
  const { url, filename } = props;
  const [isDownloading, setIsDownloading] = useState(false);
  const abortControllerRef = useRef<AbortController | null>(null);

  const handleDownload = async () => {
    if (!(url || props.blob)) return;

    setIsDownloading(true);
    abortControllerRef.current = new AbortController();
    const { signal } = abortControllerRef.current;
    let blob: Blob = props.blob || undefined;
    try {
      if (!props.blob) {
        const response = await fetch(url, {
          method: 'GET',
          signal
        });

        if (response.status !== 200) {
          const text = await response.text();
          throw new Error(text);
        }
        blob = await response.blob();
      }
      FileService.download(blob, filename);
    } catch (error) {
      if (error.name === 'AbortError') {
        console.log('Download cancelled');
      } else {
        console.error('Download failed:', error);
      }
    } finally {
      setIsDownloading(false);
    }
  };

  const handleCancel = () => {
    if (abortControllerRef.current) {
      abortControllerRef.current.abort();
      abortControllerRef.current = null;
    }
  };

  return (
    <Grid container alignItems="center" justifyContent="center">
      <Button
        color="primary"
        variant="text"
        onClick={isDownloading ? handleCancel : handleDownload}
        disabled={!(url || props.blob)}
        startIcon={
          isDownloading ? (
            <CustomLoadingProgress size={18} />
          ) : (
            <CloudDownloadIcon />
          )
        }
      >
        {isDownloading ? 'CANCEL' : 'DOWNLOAD'}
      </Button>
    </Grid>
  );
};

export default FileDownloadComponent;
